import { createBehavior } from '@area17/a17-behaviors';

const copylink = createBehavior(
  'copylink',
  {
    copy(cb) {
      navigator.clipboard.writeText(this.url).then(
        function () {
          cb();
        },
        function (...args) {
          alert('error');
          console.log('Copy error', args);
        }
      );
    },
    onClick(evt) {
      evt.preventDefault();
      if (this.timeout) {
        clearTimeout(this.timeout);
      }

      this.copy(() => {
        this.isCopied = true;
        this.timeout = setTimeout(() => {
          this.isCopied = false;
          this.render();
        }, 5000);
      });

      this.render();
    },
    render() {
      if (this.isCopied) {
        this.$defaultIcon.setAttribute('hidden', '');
        this.$copiedIcon.removeAttribute('hidden');
        this.$label.innerText = this.copiedText;
      } else {
        this.$defaultIcon.removeAttribute('hidden');
        this.$copiedIcon.setAttribute('hidden', '');
        this.$label.innerText = this.defaultText;
      }
    },
  },
  {
    init() {
      this.timeout = null;
      this.isCopied = false;
      this.$defaultIcon = this.getChild('default-icon');
      this.$copiedIcon = this.getChild('copied-icon');
      this.$label = this.getChild('label');
      this.defaultText = this.$label.getAttribute('data-copylink-default-text');
      this.copiedText = this.$label.getAttribute('data-copylink-copied-text');
      this.url = this.$node.getAttribute('href');

      this.$node.addEventListener('click', this.onClick);
    },
    destroy() {},
  }
);

export default copylink;
